// extracted by mini-css-extract-plugin
export var deleteModal = "_jr-0";